import increaseColorPointByRatio from '../../../../../common/utils/increase-color-point-by-ratio';

const primary = (params) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor } = params;
  const fallback = {
    rule: 'primaryButton.solidIcon.background.default',
    params,
  };

  const color = increaseColorPointByRatio(
    {
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.1,
      fallback,
    },
    '50'
  );

  return color.equals(targetColorPalette[50]) ? whiteColor : color;
};

export default primary;
